"use strict";

class DeveloperReportsEmailSchedulesController {

    constructor($scope, $timeout, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService, SSDateService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSDateService = SSDateService;

        self.data = SHOWSUITE.data;
        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.filtered_properties = [];

        self.enabled = false;
        self.scheduleId = null;
        self.scheduleParamErrors = {};
        self.searchText = '';

        self.allReportStatus = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 30,
                name: 'OTP Issued'
            },
            {
                id: 32,
                name: 'SPA Issued'
            },
            {
                id: 37,
                name: 'Exercised'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.optionIssuedReportStatuses = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 51,
                name: 'OTP Issued'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.uraReportStatuses = [

            {
                id: 1,
                name: 'All'
            },
            {
                id: 2,
                name: 'Sold'
            },
            {
                id:3,
                name:'Aborted'
            },
            {
                id:4,
                name:'Re-issue'
            }
        ];

        self.createScheduleParams = {
            frequency: [
                {
                    name:'Weekly',
                    value:true
                },
                {
                    name:'Bi-Weekly',
                    value:false
                },
                {
                    name:'Monthly',
                    value:false
                }
            ],
            days:[
                {
                    name:'Monday',
                    value:false
                },
                {
                    name:'Tuesday',
                    value:false
                },
                {
                    name:'Wednesday',
                    value:false
                },
                {
                    name:'Thursday',
                    value:false
                },
                {
                    name:'Friday',
                    value:false
                },
                {
                    name:'Saturday',
                    value:false
                },
                {
                    name:'Sunday',
                    value:false
                }
            ],
            day_of_month:''
        };


        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.getDeveloper();
        self.getAllReports();
        self.getProperties();
        self.getReportSettings();
    }

    getAllReports(){
        const self = this;

        self.reports = null;

        let url = 'sec/super/reports';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reports = response.data.reports;
        });
    }

    getDeveloper() {
        const self = this;

        self.selectedDeveloper = null;

        let url = 'sec/developer/profile';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.selectedDeveloper = response.data.developer;
            self.getDeveloperReports();
        });
    }

    getDeveloperReports(){
        const self = this;

        self.developerReports = null;
        self.developerReportCategories = null;

        let url = 'sec/super/developer-reports';
        let params = {
            developer_id : self.selectedDeveloper.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developerReports = response.data.developer_reports;
            self.developerReportCategories = response.data.developer_report_categories;
            self.developerReportCategories.unshift({id:0,category:'All'});
            // self.setRespectiveCategoryReports(self.selectedReportCategory);
        });
    }

    getReportSettings() {
        const self = this;

        let url = 'sec/report/report-schedules';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reportSchedules = response.data.developer_settings;
            self.extractDeveloperSettings();
        });
    }

    extractDeveloperSettings(){
        const self = this;
        self.developerReportSchedules = null;
        self.developerReportSchedules = self.reportSchedules.filter(function (setting) {
            return setting.name.startsWith('report schedule');
        });
        self.developerReportSchedules.forEach(setting => {
            setting.value = JSON.parse(setting.value);
            setting.value.properties = setting.value.properties.split(',');
            if(setting.value.hasOwnProperty('emails')){
                setting.value.emails = setting.value.emails.split(',');
            }
            setting.value.to_date =  moment(setting.value.to_date,"YYYY-MM-DD").format("DD/MM/YYYY");
            setting.value.from_date =  moment(setting.value.from_date,"YYYY-MM-DD").format("DD/MM/YYYY");
        });
    }

    // developerSelectionChanged(developer){
    //     const self = this;
    //
    //     self.selectedDeveloper = developer;
    //     this.getDeveloperReports();
    // }

    // getSelectedClass(developerReportCategory){
    //     const self = this;
    //     if(self.selectedReportCategory) {
    //         return self.selectedReportCategory.id === developerReportCategory.id ? 'selected' : '';
    //     }
    //     else {
    //         if(developerReportCategory.id === 0) {
    //             self.selectedReportCategory = developerReportCategory;
    //             return 'selected';
    //         }
    //     }
    // }

    // categorySelectionChanged(developerReportCategory){
    //     const self = this;
    //     self.selectedReportCategory = developerReportCategory;
    //     self.setRespectiveCategoryReports(developerReportCategory);
    // }

    getReportDescription(developerReport){
        const self = this;
        let report = null;
        if(self.reports)
            report = self.reports.find(function (report) {
                return report.id === developerReport.report_id;
            });

        return report ? report.description : '--';
    }

    getReport(developerReport){
        const self = this;
        let report = null;
        if(self.reports)
            report = self.reports.find(function (report) {
                return report.id === developerReport.report_id;
            });

        return report ? report : null;
    }

    /**
     * WEB-4823: whether a catalogue report has the law firm filter (Super Admin "Show Law Firm", e.g. R111).
     * Its scheduled emails are per law firm and set up in DMS → Settings → Email Notifications
     * (report code 16) or DMS → Project → Law Firms, so it is not offered here.
     *
     * @param {Object|null} report A `sec/super/reports` row.
     * @returns {boolean}
     */
    isLawFirmReport(report){
        return !!report && (report.show_law_firm === true || Number(report.show_law_firm) === 1);
    }

    /**
     * WEB-4823: the developer reports offered in the "Report" dropdown of the Schedule Email modal —
     * every assigned report except those with the law firm filter (see isLawFirmReport()). A schedule
     * being edited keeps its own report in the list, so it never shows blank.
     *
     * @returns {Array<Object>} developer_reports rows; the same array instance until the list changes.
     */
    getSchedulableDeveloperReports(){
        const self = this;

        let selectedId = self.selectedDownloadReport ? self.selectedDownloadReport.id : null;
        let rows = (self.developerReports || []).filter(function (developerReport) {
            let report = self.getReport(developerReport);
            return !self.isLawFirmReport(report) || report.id === selectedId;
        });
        // Same array instance between digests, so ng-options does not rebuild the select every time
        let key = rows.map(row => row.id).join(',');
        if (self._schedulableReportsKey !== key) {
            self._schedulableReportsKey = key;
            self._schedulableReports = rows;
        }

        return self._schedulableReports;
    }

    /**
     * Builds the label shown for a report in the "Report" dropdown of the
     * Schedule Email modal: the report name followed by its code, e.g.
     * "Sales Status Report (R050)".
     * @param {Object} developerReport Developer report row holding the report_id.
     * @returns {string} "Name (CODE)", or just the name when no code exists, or '' when the report is unknown.
     * @remarks The code disambiguates reports whose names read alike; falls back
     * gracefully so an unresolved report_id never renders "undefined".
     */
    getReportLabel(developerReport){
        const self = this;
        let report = self.getReport(developerReport);

        if(!report)
            return '';

        return report.code ? report.name + ' (' + report.code + ')' : report.name;
    }

    /**
     * Resolves the report code for a schedule row, e.g. "R050".
     * @param {number} report_id The report_id stored on the schedule setting value.
     * @returns {string} The report code, or '' when the report is unknown or has no code.
     * @remarks The schedule listing keys off report_id directly, so this walks
     * developerReports first to reuse the same lookup the dropdown uses.
     */
    getReportCode(report_id){
        const self = this;
        let developerReport = self.getDeveloperReport(report_id);
        let report = developerReport ? self.getReport(developerReport) : null;

        return report && report.code ? report.code : '';
    }

    /**
     * Builds the schedule listing title: the developer report alias followed by
     * its report code, e.g. "Sales Status (R050)".
     * @param {number} report_id The report_id stored on the schedule setting value.
     * @returns {string} "Alias (CODE)", or just the alias when no code is available.
     */
    getScheduleReportLabel(report_id){
        const self = this;
        let developerReport = self.getDeveloperReport(report_id);
        let alias = developerReport ? developerReport.alias : '';
        let code = self.getReportCode(report_id);

        return code ? alias + ' (' + code + ')' : alias;
    }

    /**
     * Builds a predicate for Angular's `filter` filter that matches a schedule
     * against ctrl.searchText (report.value.report_id and the raw setting name
     * aren't what's shown on screen, so the built-in string filter can't match
     * on them directly).
     * @returns {function(Object): boolean}
     * @remarks Matches on alias and report code — the two things the listing now
     * displays — plus category, which is no longer shown but stays searchable so
     * existing category searches keep working.
     */
    filterSchedulesBySearch(){
        const self = this;

        return function(report){
            if(!self.searchText){
                return true;
            }

            let developerReport = self.getDeveloperReport(report.value.report_id);
            let category = developerReport ? self.getDeveloperReportCategory(developerReport) : null;
            let haystack = ((developerReport ? developerReport.alias : '') + ' ' + self.getReportCode(report.value.report_id) + ' ' + (category ? category.category : '')).toLowerCase();

            return haystack.indexOf(self.searchText.toLowerCase()) !== -1;
        };
    }

    getDeveloperReport(report_id){
        const self = this;
        let developerReport = null;
            if(self.developerReports)
            developerReport = self.developerReports.find(function (value) {
                return value.report_id === report_id;
            });

        return developerReport ? developerReport : null;
    }

    getProperty(property_id){
        const self = this;
        let property = null;
        if(self.properties)
            property = self.properties.find(function (property) {
                return property.id == property_id;
            });

        return property ? property : null;
    }

    getDeveloperReportCategory(developerReport){
        const self = this;
        let developerReportCategory = null;
        if(self.developerReportCategories)
            developerReportCategory = self.developerReportCategories.find(function (value) {
                return value.id === developerReport.developer_report_category_id;
            });
        return developerReportCategory ? developerReportCategory : null;
    }

    // setRespectiveCategoryReports(developerReportCategory){
    //     const self = this;
    //
    //     if(developerReportCategory === undefined || developerReportCategory === null || developerReportCategory.id === 0){
    //         self.seletecCategoryDeveloperReports = self.developerReports;
    //         return;
    //     }
    //     self.seletecCategoryDeveloperReports = self.developerReports.filter(function (developerReport) {
    //         return developerReport.developer_report_category_id === developerReportCategory.id ? developerReport : null;
    //     });
    // }

    // getDeveloperCategoryReportCount(developerReportCategory){
    //     const self = this;
    //     let count = 0;
    //     if(developerReportCategory.id === 0){
    //         return self.developerReports.length;
    //     }
    //     self.developerReports.forEach(function (report) {
    //         report.developer_report_category_id === developerReportCategory.id ? count++ : null;
    //     });
    //     return count;
    // }

    // openDownloadReportModal(developerReport){
    //     const self = this;
    //     self.selectedDownloadReport = null;
    //     self.selectedDownloadReport = self.getReport(developerReport);
    //
    //     let statuses = null;
    //     if(self.selectedDownloadReport.show_status == 1)
    //         statuses = self.allReportStatus;
    //     else if(self.selectedDownloadReport.show_ura_status == 1)
    //         statuses = self.uraReportStatuses;
    //     else if(self.selectedDownloadReport.show_option_issued_status == 1)
    //         statuses = self.optionIssuedReportStatuses;
    //
    //     self.reportParams = {
    //         statuses : statuses
    //     };
    //
    //     if(statuses)
    //         self.reportParams.statuses.forEach(function (value) {
    //             value.check = false;
    //         });
    //
    //     if(self.selectedDownloadReport){
    //         $('#downloadReportModal').modal('show');
    //         self.selectedDownloadReport.alias = developerReport.alias;
    //         $('#from_date').datepicker({
    //             changeMonth: true,
    //             changeYear: true,
    //             dateFormat: 'dd/mm/yy'
    //         });
    //         $('#to_date').datepicker({
    //             changeMonth: true,
    //             changeYear: true,
    //             dateFormat: 'dd/mm/yy'
    //         });
    //     }
    // }

    getStatusCheck(){
        const self = this;
        if(self.selectedDownloadReport)
            return self.selectedDownloadReport.show_status || self.selectedDownloadReport.show_ura_status || self.selectedDownloadReport.show_option_issued_status;
    }

    getProperties() {
        const self = this;

        self.properties = [];
        let url = 'sec/developer/properties';
        let params = {
            status: 50, // LISTED
            summary: true
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.properties) {
                self.properties = response.data.properties;
                self.$timeout(function () {
                    $(".dashboard-select").niceSelect('update');
                });
            }
        });
    }

    updateFilter(){
        const self = this;

        if(!self.selected_property){
            self.filtered_properties = [];
        }
        else{
            // Don't process if property already filtered
            let property = self.filtered_properties.find(x => x.id == self.selected_property.id);
            if(property){
                return;
            }

            self.filtered_properties.push(self.selected_property);
        }
    }

    removeFilteredProperty(property_id){
        const self = this;

        self.filtered_properties = $.grep(self.filtered_properties, function(obj, index){
            return obj && obj.id !== property_id;
        });
    }

    statusClicked(status, event){
        const self = this;

        // Prevent the checkbox's native click-toggle, and defer our own model
        // update (and the digest that renders it) with $timeout so it runs after
        // this click event's dispatch fully completes. The browser reverts the
        // physically-clicked checkbox back to its pre-click state as part of
        // handling preventDefault() - AFTER any digest triggered synchronously
        // inside this handler - so an immediate update here would just get
        // silently overwritten by that revert when selecting a previously
        // unchecked status. Deferring guarantees our single-selection state is
        // applied last and actually sticks.
        if(event){
            event.preventDefault();
        }

        self.$timeout(function(){
            self.reportParams.report_status = status.id;

            self.reportParams.statuses.forEach(function (value) {
                value.check = (value.id == status.id);
            });
        });
    }

    // downloadReport(){
    //     const self = this;
    //     let url = '';
    //     let url_ping = '';
    //
    //     if(self.reportParams.from_date) {
    //         self.reportParams.from_date = moment(self.reportParams.from_date, "DD/MM/YYYY").format( "YYYY-MM-DD");
    //     }
    //
    //     if(self.reportParams.to_date) {
    //         self.reportParams.to_date = moment(self.reportParams.to_date, "DD/MM/YYYY").format( "YYYY-MM-DD");
    //     }
    //
    //     if(self.selectedDownloadReport.is_old_report){
    //         url = self.SSHttpService.getApiURL(self.selectedDownloadReport.url);
    //         url += '?';
    //     }
    //     else{
    //         url = self.LARAVEL_REPORT_SERVER_URL + self.selectedDownloadReport.url;
    //         url += '?api_token='+self.SSUserService.getUser().api_token;
    //     }
    //
    //     if(self.selectedDownloadReport.show_date_range) {
    //         url += '&from_date=' + self.reportParams.from_date;
    //         url += '&to_date=' + self.reportParams.to_date;
    //     }
    //
    //     if(self.getStatusCheck())
    //         url += '&status=' + self.reportParams.report_status;
    //
    //     if(self.selectedDownloadReport.allow_multiple_properties){
    //         let selected_properties = '';
    //         self.filtered_properties.forEach(function (value) {
    //             selected_properties += value.id+',';
    //         });
    //         selected_properties = selected_properties.slice(0,-1);
    //         url += '&property_id='+selected_properties;
    //         url_ping = window.open(url,'_blank');
    //     }
    //     else{
    //         let selected_property = '';
    //         self.filtered_properties.forEach(function (value) {
    //             selected_property += value.id;
    //             url += '&property_id='+selected_property;
    //             url_ping = window.open(url,'_blank');
    //         });
    //     }
    //
    //     if(url_ping)
    //     {
    //         self.SSAlertService.success("Success!", "Download completed successfully");
    //     }
    //     $('#downloadReportModal').modal('hide');
    // }

    checkFrequency(){
        const self = this;
        let check = false;
        self.createScheduleParams.frequency.forEach(value => {
            if(value.name === 'Monthly' && !value.value){
                check = true;
            }
        });
        return check;
    }

    openCreateScheduleModal(){
        const self = this;
        self.createScheduleParams.frequency.forEach(function (frequency){
            if(frequency.name == 'Weekly') frequency.value = true;
            else frequency.value = false;
        });

        self.createScheduleParams.days.forEach(function (day){
            day.value = false;
        });

        self.emails = "";

        self.selected_property = null;

        self.enabled = false;

        self.filtered_properties = [];

        self.selectedDownloadReport = null;

        self.scheduleParamErrors = {};
        self.$timeout(function() { $(".dashboard-select").niceSelect('update'); });
        $('#scheduleEmailModal').modal('show');

        $('#from_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'dd/mm/yy'
        });
        $('#to_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'dd/mm/yy'
        });
    }

    downloadReportSelected(){
        const self = this;
        let statuses = null;

        if(self.selectedDownloadReport)
            if(self.selectedDownloadReport.show_status == 1)
                statuses = self.allReportStatus;
            else if(self.selectedDownloadReport.show_ura_status == 1)
                statuses = self.uraReportStatuses;
            else if(self.selectedDownloadReport.show_option_issued_status == 1)
                statuses = self.optionIssuedReportStatuses;

        self.reportParams = {
            statuses : statuses
        };

        if(statuses)
            self.reportParams.statuses.forEach(function (value) {
                value.check = false;
            });
    }

    /**
     * Validates all required fields on the Schedule Email modal (all fields except
     * the Enabled/Disabled toggle) and populates self.scheduleParamErrors with any
     * per-field messages for display in the template.
     * @returns {boolean} true if every required field is populated, false otherwise
     */
    validateScheduleParams(){
        const self = this;

        self.scheduleParamErrors = {};
        let check = true;

        let selectedFrequency = self.createScheduleParams.frequency.filter(function (value) {
            return value.value;
        });

        if(!selectedFrequency.length){
            self.scheduleParamErrors.frequency = 'Please select a frequency';
            check = false;
        }
        else if(selectedFrequency[0].name === 'Monthly'){
            if(!self.createScheduleParams.day_of_month){
                self.scheduleParamErrors.day_of_month = 'Please enter the day of the month';
                check = false;
            }
        }
        else{
            let selectedDays = self.createScheduleParams.days.filter(function (value) {
                return value.value;
            });
            if(!selectedDays.length){
                self.scheduleParamErrors.day = 'Please select at least one day';
                check = false;
            }
        }

        if(!self.selectedDownloadReport){
            self.scheduleParamErrors.report = 'Please select a report';
            check = false;
        }

        if(!self.emails || !self.emails.trim()){
            self.scheduleParamErrors.emails = 'Please enter at least one email';
            check = false;
        }

        if(self.getStatusCheck() && (!self.reportParams || !self.reportParams.report_status)){
            self.scheduleParamErrors.status = 'Please select a status';
            check = false;
        }

        return check;
    }

    parseScheduleEmailObject(param){
        const self = this;
        param.created_by = self.SSUserService.getUser().id;
        let frequency = self.createScheduleParams.frequency.filter(function (value) {
            return value.value;
        });
        param.frequency = frequency[0].name;
        if(param.frequency === 'Weekly' || param.frequency === 'Bi-Weekly'){
            let days = self.createScheduleParams.days.filter(function (value) {
                return value.value;
            });
            days.forEach(value => {
                param.days.push(value.name);
            });
        }
        else{
            param.day_of_month = self.createScheduleParams.day_of_month;
        }
        param.report_id = self.selectedDownloadReport.id;
        param.emails = self.emails;
        self.filtered_properties.forEach(value => {
            param.properties += value.id + ',';
        });
        param.properties = param.properties.slice(0,-1);

        if(self.createScheduleParams.from_date) {
            param.from_date = moment(self.createScheduleParams.from_date, "DD/MM/YYYY").format( "YYYY-MM-DD");
        }

        if(self.createScheduleParams.to_date) {
            param.to_date = moment(self.createScheduleParams.to_date, "DD/MM/YYYY").format( "YYYY-MM-DD");
        }

        param.status = self.reportParams.report_status;
        param.is_enable = self.enabled;
    }

    scheduleEmailReport(){
        const self = this;

        if(!self.validateScheduleParams()){
            return;
        }

        let param = {
            properties : '',
            days:[]
        };

        self.parseScheduleEmailObject(param);
        let params = {
            name:'report schedule '+self.selectedDownloadReport.code,
            id: self.scheduleId? self.scheduleId: null,
            value : param
        };
        let url = 'sec/report/report-schedules-beta';

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            var reportScheduleSaved = response.data.developer_settings;
            $('#scheduleEmailModal').modal('hide');
            self.getReportSettings();
            self.SSAlertService.success("Success!", "Report settings saved successfully");
        });
    }

    toggleEmailBox(event){
        const self = this;
        $(event.target).parent().parent().next().toggle();
    }

    frequencyChanged(frequency){
        const self = this;
        self.createScheduleParams.frequency.forEach(function (value) {
            if(frequency != value)
                value.value = false;
        });
    }

    onUpdateSchedule(report){
        const self = this;
        if(!report) return;
        self.scheduleId = report.id;
        self.openCreateScheduleModal();
        if(report.value){
            if(report.value.hasOwnProperty("frequency")){
                self.createScheduleParams.frequency.forEach(function (value) {
                    if(report.value.frequency == value.name){
                        value.value = true;
                        if(report.value.frequency === 'Monthly'){
                            self.createScheduleParams.day_of_month = report.value.day_of_month ? report.value.day_of_month : "";
                        }
                        else{
                            if(report.value.hasOwnProperty('days') && report.value.days.length){
                                report.value.days.forEach(function (day) {
                                    self.createScheduleParams.days.forEach(function (scheduleDay){
                                        if(day == scheduleDay.name){
                                            scheduleDay.value = true;
                                        }
                                    });
                                });
                            }
                        }
                    }
                    else{
                        value.value = false;
                    }
                });
            }
            if(report.value.hasOwnProperty("report_id") && report.value.report_id){
                let devReport = self.getDeveloperReport(report.value.report_id);
                let mainReport = devReport? self.getReport(devReport): null;
                self.selectedDownloadReport = mainReport ? mainReport : null;
                self.downloadReportSelected();
                if(report.value.status){
                    self.reportParams.statuses.forEach((status) =>{
                        if(report.value.status == status.id){
                            self.statusClicked(status);
                        }
                    });
                }
            }
            if(report.value.hasOwnProperty("emails") && report.value.emails.length){
                self.emails = report.value.emails.join(', ');
            }
            if(report.value.hasOwnProperty('properties') && report.value.properties.length){
                report.value.properties.forEach((property) => {
                    if(property){
                        // Property may no longer be in the LISTED properties list (getProperties());
                        // skip it rather than pushing undefined, which breaks removeFilteredProperty
                        // for every chip once it hits the malformed entry.
                        let matchedProperty = self.properties.find(x => x.id == property);
                        if(matchedProperty){
                            self.filtered_properties.push(matchedProperty);
                        }
                    }
                });
            }
            if(report.value.hasOwnProperty("is_enable") && report.value.is_enable){
                self.enabled = true;
            }
        }
    }

}

DeveloperReportsEmailSchedulesController.$inject = ['$scope', '$timeout', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSDateService'];
app.controller('DeveloperReportsEmailSchedulesController', DeveloperReportsEmailSchedulesController);

